(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-mp4-video"] && !Shopify.designMode) return;
  try {
    
  if (navigator.userAgent.includes('quarantotto')) {
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      video.loop = false;
      video.muted = false;
      video.controls = true;
      video.autoplay = false;
      video.playsinline = false;
    })
  }

  } catch(e) { console.error(e); }
})();
})();
